import { type RouteObject, useRoutes } from 'react-router';

import { routeTable } from './routes/route-table';
import { RouteGuard } from './routes/RouteGuard';

/**
 * The application's routes, every one of them behind its declaration.
 *
 * There is no `<Routes>` and no `<Route>` here on purpose. The route table is
 * data (`routes/route-table.tsx`), and the one place it is turned into router
 * objects is the line below — so the guard is applied to every entry by
 * construction, and "forgot to wrap this route in the guard" is not a mistake
 * this app can make. Adding a route means adding a table entry, which does not
 * compile without an access declaration.
 *
 * Built once at module scope rather than per render: the elements are static,
 * and re-creating them on every render would remount every screen.
 */
const routeObjects: RouteObject[] = routeTable.map((route) => ({
  path: route.path,
  element: <RouteGuard route={route} />,
}));

export function App() {
  return useRoutes(routeObjects);
}
